import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import Skeleton from '@mui/material/Skeleton';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import useOnUpdate from '../../hooks/useOnUpdate';
import Template from './Template';
import {
  getTemplatesHTML,
  getTemplatesData,
  createMessage,
  createMessageData,
  editMessage,
  editMessageData,
  createPreview,
} from '../../api/ticker';
import { useNotification } from '../../context/notification';
// import { useGlobalData } from '../../context/globalData';
import previewTemplate from './preview.config';

function HtmlTemplates(props) {
  const { filename, setSideMenu, templateID, carousel, messageData, templateType, setPreview } = props;
  const [template, setTemplate] = useState(null);
  const [formFields, setFormFields] = useState({});
  const queryClient = useQueryClient();
  // const { globalData } = useGlobalData();
  const { addNotification } = useNotification();
  // const [system, setSystem] = useState(carousel.systemRuning);
  
  const {
    refetch: refetchHTML,
    isError: isErrorHTML,
    isFetching,
  } = useQuery('html', () => getTemplatesHTML(filename), {
    onSuccess: (data) => {
      setTemplate(data);
    },
    onError: (err) => {
      addNotification({ message: `Une erreur est survenue lors du chargement du formulaire ${err.message}`, severity: 'error' });
    },
  });

  const { refetch: refetchTemplateData } = useQuery('templateData', () => getTemplatesData(), {
    onSuccess: (data) => {
      setFormFields([]);
      console.log("FIELDS1DATA", data)

      const fields = data.filter((item) => item.templateID === templateID).map((item) => item.field);
      console.log("FIELDS2", fields)
      for (let index = 0; index < fields.length; index++) {
        const field = fields[index];
        console.log("REFETCH", field)
        setFormFields((prev) => ({ ...prev, [field]: '' }));
      }
    },
    onError: (err) => {
      addNotification({ message: `Une erreur est survenue lors du chargement du formulaire ${err.message}`, severity: 'error' });
    },
  });

  const { mutate: postMessageData, isLoading: postMessageDataIsLoading } = useMutation(
    (data) => (messageData?.messageData && messageData?.content ? editMessageData(data) : createMessageData(data)),
    {
      onSuccess: (data) => {
        addNotification({ message: data.message });
        queryClient.invalidateQueries('tickerData');
        queryClient.invalidateQueries('synchroDB');
        queryClient.invalidateQueries('xmlData');
      },
      onError: (err) => {
        addNotification({ message: `Une erreur est survenue lors de la création du message ${err.message}`, severity: 'error' });
      },
    },
  );

  const { mutate: postMessage, isLoading: postMessageIsLoading } = useMutation(
    (data) =>
      messageData?.messageData && messageData?.content ?  editMessage({ ...data }, messageData.messageID) : createMessage(data),
    {
      onSuccess: (res) => {
        const messageDataID = Math.floor(1 + Math.random() * (99999 - 1));
        for (let index = 0; index < res.data.length; index++) {

          let body = { ...res.data[index], messageID: res.messageID, messageDataID: messageDataID + index };
          if (messageData?.messageData) {
            body = {
              ...res.data[index],
              messageID: parseInt(res.messageID),
              messageDataID: messageData.messageData[index].messageDataID,
            };
          }
          postMessageData(body);
        }
        setSideMenu(false);
      },
      onError: (err) => {
        addNotification({ message: `Une erreur est survenue lors de la création du message ${err.message}`, severity: 'error' });
      },
    },
  );

  const { mutate: postPreview } = useMutation((data) => /* sendPreview(data) */ createPreview(data), {
    onSuccess: (data) => {
      setTimeout(() => {
        const path = data.fileList[0].split('/');
        const filePath = `${path[path.length - 2]}/${path[path.length - 1].replace('.1', '')}`;
        setPreview({ file: filePath, loading: false });
      }, 2500);
    },
    onError: (err) => {
      console.log(err);
    },
  });

  // useEffect(() => {
  //   setSystem(globalData.tab?.systemRuning);
  // }, [globalData]);

  useOnUpdate(() => {
    const fields = Object.keys(formFields);
    if (fields) {
      for (let index = 0; index < fields.length; index++) {
        const field = fields[index];
        const input = document.getElementById(`${field}`);
        const defaultValue = messageData?.messageData?.filter((data) => data.field === field)[0];
        if (input && defaultValue) {
          if (input.localName === 'select') {
            const { options } = input;
            setTimeout(() => {
              const arrOptions = [...options];
              const defaultOption = arrOptions.filter((opt) => opt.value === defaultValue.value)[0];
              if (!defaultOption) return;
              defaultOption.selected = 'selected';
            }, 200);
          }
          input.defaultValue = defaultValue?.value || '';
        }
      }
      const cancelButton = document.getElementById('cancel');
      cancelButton?.addEventListener('click', () => {
        sessionStorage.removeItem('RUBRIQUE_1');
        sessionStorage.removeItem('RUBRIQUE_2')

        setSideMenu(false);
      });
    }

    const script = document.getElementById('templateScript');

    if (!script) return;
    script.parentNode.removeChild(script);

    const newScript = document.createElement('script');
    newScript.setAttribute('id', 'generatedScript');
    if (script.src) {
      newScript.src = script.src;
    } else if (script.textContent) {
      newScript.textContent = script.textContent;
    } else if (script.innerText) {
      newScript.innerText = script.innerText;
    }
    document.body.appendChild(newScript);
  }, [formFields]);

  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    return () => {
      const scriptExist = document.getElementById('generatedScript');
      if (scriptExist) {
        scriptExist.parentNode.removeChild(scriptExist);
      }
    };
  }, [templateType]);

  useOnUpdate(() => {
    refetchHTML();
    refetchTemplateData();
  }, [filename]);

  function handleSubmit(e) {
    const inputValues = new FormData(e.target);

    const fields = Object.keys(formFields);
    sessionStorage.removeItem('RUBRIQUE_1');
    sessionStorage.removeItem('RUBRIQUE_2')
    console.log(e.target, inputValues, fields)

    const data = [];
    for (let index = 0; index < fields.length; index++) {
      const field = fields[index];

      data.push({ field, value: inputValues.get(field) });

    }
    const messageID = Math.floor(1 + Math.random() * (99999 - 1));
    console.log(data, messageData, fields, formFields)
 
    postMessage({
      ...messageData,
      position: messageData?.position || 0,
      carouselID: carousel.carouselID,
      isLive: messageData?.isLive || false,
      messageID,
      isVisible: messageData?.isVisible !== undefined ? messageData?.isVisible : true,
      templateID,
      templateType,
      data,
    });
  }
  // function handleResetCounter(e) {
  //   const inputValues = new FormData(e.target);
  //   const fields = Object.keys(formFields);
  //   sessionStorage.removeItem('RUBRIQUE_1');
  //   sessionStorage.removeItem('RUBRIQUE_2')

  //   const data = [];
  //   for (let index = 0; index < fields.length; index++) {
  //     const field = fields[index];

  //     data.push({ field, value: inputValues.get(field) });

  //   }
  //   const messageID = Math.floor(1 + Math.random() * (99999 - 1));

  //   postMessage({
  //     ...messageData,
  //     position: messageData?.position || 0,
  //     carouselID: carousel.carouselID,
  //     isLive: messageData?.isLive || false,
  //     messageID,
  //     isVisible: messageData?.isVisible !== undefined ? messageData?.isVisible : true,
  //     templateID,
  //     templateType,
  //     data,
  //     counter: 0
  //   });
  // }
  function handlePreview(e) {
    setPreview({ file: '', loading: true });
    const inputValues = new FormData(e.target);
    const fields = Object.keys(formFields);
    const data = { fields: [], templateType, sceneID: 'PWTICKER' };
    if (carousel.languageID === 1) {
      // AR SCENE
      data.sceneID = 'ARTICKER';
    }
    for (let index = 0; index < fields.length; index++) {
      const field = fields[index];
      data.fields.push({ field: field.toUpperCase(), value: inputValues.get(field), templateType });
    }
    const body = previewTemplate(data);
    postPreview(body);
  }

  if (isErrorHTML) {
    return <div>Template introuvable.</div>;
  }

  return postMessageIsLoading || postMessageDataIsLoading ? (
    <CircularProgress size={30} />
  ) : (
    <form
      id="templateForm"
      className="htmlTemplate"
      onSubmit={(e) => {
        e.preventDefault();
        sessionStorage.removeItem('RUBRIQUE_1');
        sessionStorage.removeItem('RUBRIQUE_2')
        if (e.nativeEvent.submitter.id === 'preview') {
          handlePreview(e);
        } 
        // else if(e.nativeEvent.submitter.id === 'reset-counter'){
        //   handleResetCounter(e);
        // }
        else {
          handleSubmit(e);
        }
      }}
    >
      {isFetching ? (
        <Stack spacing={3}>
          {[0, 1, 2].map((n) => (
            <Stack key={`skeleton_${n}`} spacing={1}>
              <Skeleton variant="text" width={200} sx={{ bgcolor: 'var(--dark-800)' }} />
              <Skeleton variant="rectangular" height={35} sx={{ bgcolor: 'var(--dark-800)' }} />
            </Stack>
          ))}
        </Stack>
      ) : (
        <Template template={template} />
      )}
    </form>
  );
}

HtmlTemplates.propTypes = {
  filename: PropTypes.string,
  templateID: PropTypes.number,
  templateType: PropTypes.number,
  setSideMenu: PropTypes.func,
  setPreview: PropTypes.func,
  carousel: PropTypes.object,
  messageData: PropTypes.object,
};

HtmlTemplates.defaultProps = {
  filename: '',
  templateID: 0,
  templateType: 0,
  carousel: {},
  setSideMenu: () => { },
  setPreview: () => { },
  messageData: {},
};

export default HtmlTemplates;
